import type { TourConfig } from '../../types/tour.types'

// Member profile / account settings. Anchors are `data-tour` attributes on the
// three cards of the view (added alongside this tour). The cards are always
// rendered (skeleton loaders swap in while loading), so no step is optional.
const profileTour: TourConfig = {
  id: 'profile',
  title: 'Keep your account up to date',
  module: 'Account',
  routeName: 'Profile',
  order: 22,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Your account, your details',
      body: 'This is your **member profile** — the one place to keep your personal details current, review your plan and manage how you sign in. A few minutes here keeps exports, invoices and notifications pointed at the right person.',
    },
    {
      id: 'details',
      target: '[data-tour="pf-profile"]',
      placement: 'end',
      title: 'Update your personal details',
      body: 'Edit your **name, email, company and country**, then **Save**. Keeping these accurate means your invoices and account communications always reach you.',
    },
    {
      id: 'plan',
      target: '[data-tour="pf-plan"]',
      placement: 'auto',
      title: 'See your plan at a glance',
      body: 'Check your **current plan and remaining credits** here, so you always know how much prospecting you have left before topping up.',
    },
    {
      id: 'actions',
      target: '[data-tour="pf-actions"]',
      placement: 'start',
      title: 'Secure how you sign in',
      body: 'Manage account security from here — **change your password** and set up **two-factor authentication** to add an extra layer of protection to your account.',
    },
  ],
}

export default profileTour
